import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback } from "reactstrap";
import Select from "react-select";

import { getSectors } from "common/services/data-types.service";
import { normalize } from "common/lib/normalize";

const SelectSector = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.sector && validation.errors.sector
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.sector && validation.errors.sector
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getSectors({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });

    mainOptions.unshift({ value: null, label: "None" });
    return mainOptions;
  }, [data]);

  return (
    <>
      <Label htmlFor="sector-field" className="form-label">
        Sector
      </Label>
      <Select
        name="sector"
        id="sector"
        value={validation.values.sector.value ? validation.values.sector : null}
        placeholder="Select sector"
        onChange={(value: any) => {
          validation.setFieldValue("sector", value);
          validation.setFieldError("sector", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("sector", true)}
        className={
          validation.touched.sector && validation.errors.sector
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.sector?.value}</FormFeedback>
    </>
  );
};

export default SelectSector;
